import { f as BarGaugeDisplayMode, g as BarGaugeNamePlacement, e as BarGaugeSizing, h as BarGaugeValueMode } from '../../../../../common.gen-CZ1M9G8L.js';

const pluginVersion = "12.1.0-pre";
const defaultOptions = {
  displayMode: BarGaugeDisplayMode.Gradient,
  maxVizHeight: 300,
  minVizHeight: 16,
  minVizWidth: 8,
  namePlacement: BarGaugeNamePlacement.Auto,
  showUnfilled: true,
  sizing: BarGaugeSizing.Auto,
  valueMode: BarGaugeValueMode.Color
};

export { defaultOptions, pluginVersion };
